import React, { useState } from "react";

import { tranStr } from "../../utils/translation";

import "./BenchmarkSelectionFilterSlider.css";
import PropTypes from "prop-types";
import { SelectOtlEntity } from "../post-contract-2.0/PostContractForm.components";
import isEmpty from "../../validation/is-empty";
import Spinner from "../common/Spinner";

export function PortfolioInputSingle(props) {
  const { value, onChange, placeholder, icon } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "benchmark-selection-filter-input-icon";
  if (focus || value !== "")
    iconType = "benchmark-selection-filter-input-icon-focus";

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className={iconType}>{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <input
            className="benchmark-selection-filter-input"
            type="text"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
          ></input>
        </div>
      </div>
    </div>
  );
}

BenchmarkModeToggle.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
};

export function BenchmarkModeToggle(props) {
  const { value, onChange, placeholder, icon, disabled } = props;

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className="benchmark-selection-filter-input-icon">{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <div className="benchmarking-disclaimer-acceptance">
            <input
              id={"BenchmarkModeToggle"}
              type="checkbox"
              checked={value}
              disabled={disabled}
              onChange={() => onChange(!value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
PortfolioSelectSingle.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  options: PropTypes.array,
  multiple: PropTypes.bool,
  setChildSelection: PropTypes.func,
};
export function PortfolioSelectSingle(props) {
  const { value, onChange, placeholder, icon, options, multiple } = props;
  const { setChildSelection } = props;
  const { isLoading } = props;

  const [open, setOpen] = useState(false);
  const [focus, setFocus] = useState(false);

  const [selectedValues, setSelectedValues] = useState([]);

  let iconType = "benchmark-selection-filter-input-icon";
  if (focus || value !== "")
    iconType = "benchmark-selection-filter-input-icon-focus";

  if (isLoading) {
    return (
      <div className="benchmark-selection-filter-input-container">
        <div className={iconType}>{icon}</div>
        <div className="benchmark-selection-filter-input-col">
          <div className="benchmark-selection-filter-input-heading">
            {placeholder}
          </div>
          <div className="benchmark-selection-filter-input-row">
            <Spinner width="20px" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className={iconType}>{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <div className="nested-dropdown" style={{ width: "100%" }}>
            {multiple && (
              <button
                id={"nested-drop-down-toggle-button"}
                onClick={() => {
                  setOpen(!open);
                  setFocus(open);
                }}
                aria-expanded={open}
                className="multiple-selection-dropdown-button"
                onFocus={() => setFocus(true)}
                onBlur={() => {
                  setFocus(false);
                }}
              >
                <div className="multiple-selection-dropdown-button-content">
                  <div
                    className="multiple-selection-dropdown-button-content-label"
                    title={
                      isEmpty(selectedValues)
                        ? tranStr("")
                        : selectedValues.join(" | ")
                    }
                  >
                    {isEmpty(selectedValues)
                      ? tranStr(placeholder)
                      : selectedValues.join(" | ")}
                  </div>
                  {open ? (
                    <i className="fas fa-chevron-up"></i>
                  ) : (
                    <i className="fas fa-chevron-down"></i>
                  )}
                </div>
              </button>
            )}
            {/* Dropdown menu */}

            {!multiple && (
              <select
                className="benchmark-selection-filter-input"
                style={{ marginTop: "5px" }}
                type="text"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                  if (setChildSelection) {
                    setChildSelection("");
                  }
                }}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
              >
                {selectOptions(options, multiple)}
              </select>
            )}

            {open && (
              <div className="nested-dropdown-menu nested-dropdown-multiple">
                {selectOptions(options, multiple)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  function selectOptions(availableOptions, multiple) {
    return availableOptions.map((option, index) => (
      <div
        className="nested-dropdown-item"
        style={{ hover: { backgroundColor: "red" } }}
        key={option.value + index}
      >
        {!multiple && (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        )}
        {multiple && (
          <label className="multiple-selection-checkbox-label">
            {index > 0 && (
              <>
                <input
                  type="checkbox"
                  key={option.label}
                  value={option.value}
                  className="multiple-selection-checkbox"
                  checked={selectedValues.includes(option.value)}
                  onClick={(e) => {
                    let temp = [];
                    temp = selectedValues;
                    e.target.checked
                      ? temp.push(option.value)
                      : temp.splice(temp.indexOf(option.value), 1);
                    setSelectedValues(temp);
                    onChange(temp.toString());
                  }}
                />
                <span className="multiple-selection-checkbox-label-highlight">
                  {option.label}
                </span>
              </>
            )}
            {index === 0 && (
              <button
                onClick={() => {
                  setSelectedValues([]);
                  onChange([].toString());
                  setOpen(false);
                }}
                className="nested-dropdown-link multiple-selection-clear-button"
              >
                {option.label}
              </button>
            )}
          </label>
        )}
      </div>
    ));
  }
}

export function PortfolioSelectSingleFilter(props) {
  const { value, onChange, placeholder, icon, options } = props;
  const { filter } = props;
  const [focus, setFocus] = useState(false);
  let iconType = "benchmark-selection-filter-input-icon";
  if (focus || value !== "")
    iconType = "benchmark-selection-filter-input-icon-focus";

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className={iconType}>{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <select
            className="benchmark-selection-filter-input"
            type="text"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          >
            {selectOptions(options)}
          </select>
        </div>
      </div>
    </div>
  );

  function selectOptions(availableOptions) {
    return availableOptions.map((option) => {
      if (option.type === filter || option.type === "") {
        return (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        );
      } else {
        return null;
      }
    });
  }
}

export function PortfolioInputDouble(props) {
  const { value1, onChange1 } = props;
  const { value2, onChange2 } = props;
  const { placeholder, icon } = props;
  const [focus, setFocus] = useState(false);

  let iconType = "benchmark-selection-filter-input-icon";
  if (focus || value1 !== "" || value2 !== "")
    iconType = "benchmark-selection-filter-input-icon-focus";

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className={iconType}>{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <input
            className="benchmark-selection-filter-input-pair"
            type="text"
            value={value1}
            onChange={(e) => {
              onChange1(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
            placeholder={tranStr("Min")}
          ></input>
          <input
            className="benchmark-selection-filter-input-pair-second"
            type="text"
            value={value2}
            onChange={(e) => {
              onChange2(e.target.value);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            autoComplete="off"
            placeholder={tranStr("Max")}
          ></input>
        </div>
      </div>
    </div>
  );
}
PortfolioSelectEntity.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  setEntity: PropTypes.func,
};
export function PortfolioSelectEntity(props) {
  const { value, placeholder, icon, setEntity } = props;

  const [focus] = useState(false);
  let iconType = "benchmark-selection-filter-input-icon";
  if (focus || value !== "") {
    iconType = "benchmark-selection-filter-input-icon-focus";
  }

  return (
    <div className="benchmark-selection-filter-input-container">
      <div className={iconType}>{icon}</div>
      <div className="benchmark-selection-filter-input-col">
        <div className="benchmark-selection-filter-input-heading">
          {placeholder}
        </div>
        <div className="benchmark-selection-filter-input-row">
          <SelectOtlEntity setEntity={setEntity} />
        </div>
      </div>
    </div>
  );
}
